import router from 'next/router';
import {IS_CLIENT_SIDE} from '../common/shared/utils/constants';
import {isTrue} from '../common/shared/utils/isTrue';
import {events} from '../domain/content/[seriesId]/viewer/[productId]/constant/talkViewerEvents';
import {setIsViewerEndExposed as setIsViewerEndExposedAction} from '../domain/content/[seriesId]/viewer/[productId]/state/viewerEndSlice';
import {setNonstopWatching} from '../domain/content/[seriesId]/viewer/[productId]/state/viewerInfoSlice';
import {fetchViewerEnd} from '../domain/content/[seriesId]/viewer/[productId]/util/fetchViewerEnd';
import {updateCacheIsAlarmOn} from '../domain/content/[seriesId]/viewer/[productId]/util/updateCacheIsAlarmOn';
import {updateCacheIsLikeOn} from '../domain/content/[seriesId]/viewer/[productId]/util/updateCacheIsLikeOn';
import {trackEvent as internalTrackEvent} from '../logging/trackEvent';
import {AppStore} from '../state/store';

export function initKpWeb(store: AppStore) {
  if (!IS_CLIENT_SIDE || window.KPWeb) {
    return;
  }

  function reload() {
    router.reload();
  }

  function setAccessToken(tokenJsonString: string) {
    console.log('::: call setAccessToken :::', tokenJsonString);
  }

  function setIsNonstopWatching(isNonstop: boolean) {
    const currentSeriesId = store.getState().viewerInfo.currentSeriesId;
    if (currentSeriesId) {
      store.dispatch(
        setNonstopWatching({
          seriesId: currentSeriesId,
          isNonstopWatching: isTrue(isNonstop),
        })
      );
    }
  }
  function setIsAlarmOn(isAlarmOn: boolean) {
    const currentProductId = store.getState().viewerInfo.currentProductId;
    const currentSeriesId = store.getState().viewerInfo.currentSeriesId;
    if (!currentProductId || !currentSeriesId) {
      return;
    }
    updateCacheIsAlarmOn({
      seriesId: currentSeriesId,
      productId: currentProductId,
      isAlarmOn: isTrue(isAlarmOn),
    });
  }
  function getIsViewerEndExposed() {
    return store.getState().viewerEnd.isExposed;
  }
  function setIsViewerEndExposed(exposed: boolean) {
    store.dispatch(setIsViewerEndExposedAction(!!isTrue(exposed)));
  }
  function setIsLikeOn(isLikeOn: boolean) {
    const currentProductId = store.getState().viewerInfo.currentProductId;
    const currentSeriesId = store.getState().viewerInfo.currentSeriesId;
    if (!currentProductId || !currentSeriesId) {
      return;
    }
    updateCacheIsLikeOn({
      seriesId: currentSeriesId,
      productId: currentProductId,
      isLikeOn: isTrue(isLikeOn),
    });
  }
  function refreshViewerEnd() {
    const currentProductId = store.getState().viewerInfo.currentProductId;
    const currentSeriesId = store.getState().viewerInfo.currentSeriesId;
    if (!currentProductId || !currentSeriesId) {
      return;
    }
    fetchViewerEnd({
      seriesId: currentSeriesId,
      productId: currentProductId,
      apiPath: window?.KPApp?.getViewerEndPath(),
    });
  }

  function trackEvent(
    eventObjectJsonString: string | object,
    isExternalPage?: boolean
  ): void {
    internalTrackEvent(
      typeof eventObjectJsonString === 'string'
        ? JSON.parse(eventObjectJsonString)
        : eventObjectJsonString,
      // KPWeb 인터페이스에 의해 로깅되는 경우는 외부페이지로 판단합니다. (이벤트페이지의 경우에는 KpParent로 로깅)
      isExternalPage
    );
  }

  // 백버튼 클릭 이벤트에 true를 보내면 앱에서 아무 처리를 하지 않고 웹 처리만 하고 끝납니다. false를 보내면 앱에서 실제 백버튼으로 동작합니다.
  function backButtonClicked() {
    const talkViewerState = store.getState().talkViewer;
    if (talkViewerState.fullscreen) {
      store.dispatch(events.fullscreenHideRequested());
      return true;
    }
    return false;
  }

  window.KPWeb = {
    reload,
    setAccessToken,
    setIsAlarmOn,
    setIsNonstopWatching,
    setIsViewerEndExposed,
    setIsLikeOn,
    getIsViewerEndExposed,
    refreshViewerEnd,
    trackEvent,
    backButtonClicked,
  };

  window.addEventListener('message', e => {
    // 빌링 등 타 팝업, 아이프레임에서 로깅하기 위해 추가합니다
    if (e.data?.target === 'KPWeb.trackEvent') {
      const IS_EXTERNAL_PAGE = true;
      trackEvent(e.data?.data, IS_EXTERNAL_PAGE);
    }
  });
}
